document.addEventListener('teeinblue-event-component-injected', function() {
  const elementToMove = document.querySelector('div[id*=ticksell_ticksell_container]');
  const insertAfterElement = document.querySelector('#teeFormActions');
  if (elementToMove && insertAfterElement) {        
    insertAfterElement.before(elementToMove)
  } 

  window.teeinblue.transformBeforeAddToCart = (input) => {
    let output = input;

    if (typeof originalTransform === 'function') {
      output = originalTransform(input);
    }

    const checkedUpsell = document.querySelector('#ticksell-container input[type="checkbox"]:checked');
    if (checkedUpsell) {
      const upsellGroup = checkedUpsell.closest('.ticksell-group');
      if (upsellGroup) {
        const id = upsellGroup.getAttribute('data-variant-id');
        const quantity = 1;
        if (id) {
          if (Array.isArray(output)) {
            output.push({ id, quantity });
          } else {
            output = [output, { id, quantity }];
          }
        }
      }
    }

    return output;
  };
});